import { PermissionContext } from 'src/app/shared/rpe/rpe-permissions.model';

export interface UserEffectivePermissionsStateModel {
  userId: number | null;
  permissionContexts: PermissionContext[];
  activeLocationId: number | null;
  permissionsResolved: boolean;
  loadStarted: boolean;
}

export const defaultUserEffectivePermissionsState: UserEffectivePermissionsStateModel =
  {
    userId: null,
    permissionContexts: [],
    activeLocationId: null,
    permissionsResolved: false,
    loadStarted: false,
  };
